export default "/images/show_sys_logo.svg?c9b008f4a1e0dd1ea06963285c934ce6";